import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, normalizeStyle as _normalizeStyle, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "label-container rounded-base-small" }
const _hoisted_3 = ["step", "min", "max"]

import Vue, { onMounted, ref } from 'vue';
import Suggest from '@/corePagesModule/components/Suggest.vue';
import { computed } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { MAX_OF_ADJUST_ANNOUNCE_RATE, MIN_OF_ADJUST_ANNOUNCE_RATE, STEP_OF_ADJUST_ANNOUNCE_RATE } from '@/coreDomainsModule/constants';
import { watch } from 'vue';
import { useSelectableNumberInputStore } from '../store/useSelectableNumberInputStore';
import { SelectableNumberInputOptions } from '@/coreDomainsModule/entities/inputOptions';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectableNumberInput',
  props: {
    displayValue: {},
    defaultValue: {},
    options: {}
  },
  emits: ["confirmed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const selectableNumberInputStore = useSelectableNumberInputStore();
const { state, updateInputValue, updateBySelectedSuggest, hoverSuggests, leaveSuggests, selectInput, leaveInput } =
  selectableNumberInputStore;

const result = ref<DOMRect>();
const xLength = ref(0);
const yLength = ref(0);

const emits = __emit;

watch(
  () => props.defaultValue,
  (newValue) => {
    updateInputValue(newValue);
  },
  { immediate: true } // ないと初回が反映されないので必要
);

/**
 * クリックされたらinputを表示してフォーカスする
 */
const onClickLabel = () => {
  selectInput();
  Vue.nextTick(() => {
    document.getElementById('selectable-input-container__input')?.focus();
  });
  const element = document.getElementById(selectableInputContainerId.value);
  if (!element) return;
  result.value = element.getBoundingClientRect();
  xLength.value = result.value.left;
  yLength.value = result.value.bottom;
};

/**
 * サジェストが選択された時の処理
 * @param suggest - 選択されたサジェスト
 */
const onClickSuggest = (suggest: string) => {
  updateBySelectedSuggest(suggest, props.options);
  leaveSuggests();
  confirmValue();
};
/**
 * inputのフォーカスが外れた時の処理
 */
const onBlurInput = () => {
  // マウスがsuggestに乗っている時のblurは選択肢を選んだ時なので回避(onClickSuggestが走らなくなる) || 選択肢がない時
  if (!state.isHoverSuggests || computedOptions.value.length === 0) {
    confirmValue();
  }
};
/**
 * 値を確定
 */
const confirmValue = () => {
  leaveInput();
  emits('confirmed', state.inputValue);
};
/**
 * 表示するサジェストのリスト
 */
const computedOptions = computed((): string[] => {
  return props.options.filter((option) => option.value.toString().includes(state.inputValue.toString())).map((option) => option.text);
});

// ランダムID生成
const selectableInputContainerId = ref<string>('');
onMounted(() => {
  selectableInputContainerId.value = Math.random().toString(32).substring(2);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: selectableInputContainerId.value,
    class: "selectable-input-container"
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "label-container__text selectable-input-container__text-box selectable-input-container__text-box--label",
        onClick: onClickLabel
      }, _toDisplayString(_ctx.displayValue), 1),
      _createVNode(SvgLoader, {
        class: "label-container__icon",
        name: 'arrowDown',
        onClick: onClickLabel
      })
    ], 512), [
      [_vShow, !_unref(state).isSelectInput]
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "selectable-input-container__input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).inputValue) = $event)),
      class: "selectable-input-container__text-box selectable-input-container__text-box--input rounded-base-small",
      type: "number",
      step: _unref(STEP_OF_ADJUST_ANNOUNCE_RATE),
      min: _unref(MIN_OF_ADJUST_ANNOUNCE_RATE),
      max: _unref(MAX_OF_ADJUST_ANNOUNCE_RATE),
      onBlur: onBlurInput
    }, null, 40, _hoisted_3), [
      [_vShow, _unref(state).isSelectInput],
      [_vModelText, _unref(state).inputValue]
    ]),
    (computedOptions.value.length > 0 && _unref(state).isSelectInput)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createVNode(Suggest, {
            class: "selectable-input-container__suggests rounded-base-small",
            style: _normalizeStyle({
          top: `${yLength.value}px`,
          left: `${xLength.value}px`,
        }),
            value: _unref(state).inputValue,
            options: computedOptions.value,
            onClickSuggest: onClickSuggest,
            onMouseover: _unref(hoverSuggests),
            onMouseleave: _unref(leaveSuggests)
          }, null, 8, ["style", "value", "options", "onMouseover", "onMouseleave"])
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})